export class Tabs {
    private container: HTMLElement;
    private buttons: NodeListOf<HTMLButtonElement>;

    constructor(container: HTMLElement) {
        this.container = container;
        this.buttons = this.container.querySelectorAll<HTMLButtonElement>('.tab-btn');
        this.init();
    }

    private init() {
        this.buttons.forEach(btn => btn.addEventListener('click', (e) => {
            e.preventDefault(); // предотвращаем прыжок
            this.switchTab(btn);
        }));
    }

    private switchTab(button: HTMLButtonElement) {
        const tabId = button.dataset.tab;
        if (!tabId) return;

        const type = this.container.dataset.tabs;

        // Переключаем класс active на кнопках
        this.buttons.forEach(b => b.classList.toggle('active', b === button));

        let contentContainer: HTMLElement | null = null;

        if (type === 'main') {
            contentContainer = this.container.nextElementSibling.nextElementSibling as HTMLElement | null;
        } else {
            const nestedParent = this.container.closest('.tabs-head, .nested-tabs');
            if (nestedParent) {
                contentContainer = nestedParent.nextElementSibling as HTMLElement | null;
            }
        }

        if (!contentContainer) return;

        // Переключаем панели
        const panels = Array.from(contentContainer.children)
            .filter(child => child.classList.contains('tab-panel')) as HTMLElement[];

        panels.forEach(panel => {
            const isActive = panel.dataset.tabPanel === tabId;
            panel.style.display = isActive ? '' : 'none';
            panel.classList.toggle('active', isActive);
        });
    }
}

// Инициализация для всех табов на странице

